<script>
import CondusefProductForm from "@components/support-areas/internal-control/condusef/condusef-product-form.vue";
import SepomexAddressForm from "@components/support-areas/internal-control/condusef/sepomex-address-form.vue";
import Datepicker from "vuejs-datepicker";
import {
  attentionLevels,
  channels,
  complaintAnswers,
  complaintStatus,
  genders, penalties, personTypes,
  pori
} from "@/helpers/complaits/catalogs";

export default {
  name: "claims-form",
  components: {
    CondusefProductForm,
    SepomexAddressForm,
    Datepicker
  },
  data: () => ({
    channels,
    attentionLevels,
    pori,
    complaintStatus,
    genders,
    complaintAnswers,
    penalties,
    personTypes,
    form: {
      noTrim: null,
      num: 1,
      importeAbonado: null,
      folio: "",
      fecReclamacion: "",
      fecAtencion: "",
      monetario: "NO",
      montoReclamado: null,
      folioCondusef: null,
      fecAbonoImporte: null,
      medioId: 1,
      producto: "",
      causaId: null,
      pori: "NO",
      estatus: 1,
      estadosId: null,
      nivelATId: null,
      munId: null,
      locId: null,
      colId: null,
      cp: null,
      tipoPersona: 1,
      quejasRespuesta: null,
      sexo: "H",
      edad: null,
      fecResolucion: null,
      fecNotifUsuario: null,
      reversa: null,
      operacionExtranjero: null
    },
  }),
  methods: {
    productsChangedHandler(form) {
      this.form.producto = form.product;
      this.form.causaId = form.causaId;
    },
    async submitComplaint() {
      try {
        await axios.post('/api/condusef/reune/claim', this.form)
        this.$vs.notify({
          title: "Éxito",
          text: "Queja registrada",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
      } catch (e) {
        if (e.response.status === 422) {
          this.errorMessage = e.response.data.errors;
          return;
        }
        this.$vs.notify({
          title: "Error",
          text: e.response.data.error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      }
    },
    addressChangedHandler(address) {
      this.form.locId = address.locId;
      this.form.cp = address.cp;
      this.form.estadosId = address.estadosId;
      this.form.munId = address.munId;
      this.form.colId = address.colId;
    }
  }
}
</script>

<template>
  <div>
    <div class="flex gap-4">
      <div class="w-6/12">
        <condusef-product-form variant="reune" for="for_claims" @onChange="productsChangedHandler"/>
        <vx-card title="Datos de la solicitud" class="mt-3">
          <div class="grid grid-cols-2 gap-4">
            <vs-input class="w-full" label="Folio de atención" v-model="form.folio"/>
            <vs-input class="w-full" label="Número de reclamación" v-model="form.num"/>
            <vs-select class="w-full" label="Trimestre" v-model="form.noTrim">
              <vs-select-item
                  v-for="month in [{value: 1, text: 'Enero-Marzo'}, {value: 2, text: 'Abril-Junio'}, {value: 3, text: 'Julio-Septiembre'}, {value: 4, text: 'Octubre-Diciembre'}]"
                  :key="month.value"
                  :value="month.value"
                  :text="month.text"/>
            </vs-select>
            <vs-input type="date" class="w-full" label="Fecha reclamación" v-model="form.fecReclamacion"/>
            <vs-select class="w-full" label="Estatus" v-model="form.estatus">
              <vs-select-item
                  v-for="status in complaintStatus"
                  :key="status.id"
                  :value="status.id"
                  :text="status.name"/>
            </vs-select>
            <vs-input type="date" class="w-full" label="Fecha atención" v-model="form.fecAtencion"
                      v-if="form.estatus === 2"/>
            <vs-select class="w-full" label="Medio de Recepción" v-model="form.medioId">
              <vs-select-item
                  v-for="channel in channels"
                  :key="channel.id"
                  :value="channel.id"
                  :text="channel.name"/>
            </vs-select>
            <vs-select class="w-full" label="Nivel de atención" v-model="form.nivelATId" v-if="form.estatus === 2">
              <vs-select-item
                  v-for="attentionLevel in attentionLevels"
                  :key="attentionLevel.id"
                  :value="attentionLevel.id"
                  :text="attentionLevel.name"/>
            </vs-select>
            <vs-select class="w-full" label="PORI" v-model="form.pori">
              <vs-select-item
                  v-for="p in pori"
                  :key="p.id"
                  :value="p.id"
                  :text="p.name"/>
            </vs-select>
            <vs-select class="w-full" label="Monetario" v-model="form.monetario">
              <vs-select-item
                  v-for="p in pori"
                  :key="p.id"
                  :value="p.id"
                  :text="p.name"/>
            </vs-select>
            <vs-input class="w-full" label="Monto reclamado" v-model="form.montoReclamado"
                      v-if="form.monetario === 'SI'"/>
            <vs-input class="w-full" label="Importe abonado" v-model="form.importeAbonado"
                      v-if="form.monetario === 'SI'"/>
            <vs-input type="date" class="w-full" label="Fecha abono" v-model="form.fecAbonoImporte"
                      v-if="form.monetario === 'SI'"/>
            <vs-input type="date" class="w-full" label="F. de notificación" v-model="form.fecNotifUsuario"
                      v-if="form.estatus === 2"/>
            <vs-input type="date" class="w-full" label="F. de resolución" v-model="form.fecResolucion"
                      v-if="form.estatus === 2"/>
            <vs-select class="w-full" label="Sentido de la resolución" v-model="form.quejasRespuesta"
                       v-if="form.estatus === 2">
              <vs-select-item
                  v-for="answer in complaintAnswers"
                  :key="answer.id"
                  :value="answer.id"
                  :text="answer.name"/>
            </vs-select>
            <vs-input
                class="w-full"
                label="Folio CONDUSEF"
                v-model="form.folioCondusef"
                v-if="form.medioId === 6 || form.medioId === 7"/>
            <vs-select class="w-full" label="Reversa SIGE" v-model="form.reversa" v-if="form.medioId === 6">
              <vs-select-item
                  v-for="p in [{id: 1, name: 'Sí'}, {id: 0, name: 'No'}]"
                  :key="p.id"
                  :value="p.id"
                  :text="p.name"/>
            </vs-select>
            <!--<vs-select class="w-full" label="Operación en el extranjero" v-model="form.operacionExtranjero">
              <vs-select-item
                  v-for="p in pori"
                  :key="p.id"
                  :value="p.id"
                  :text="p.name"/>
            </vs-select>-->
          </div>
        </vx-card>
      </div>
      <div class="w-6/12">
        <div class="">
          <sepomex-address-form @onChange="addressChangedHandler"/>
          <vx-card title="Datos de la persona" class="mt-3">
            <div class="grid grid-cols-3 gap-3">
              <vs-select class="w-full" label="Tipo persona" v-model="form.tipoPersona">
                <vs-select-item
                    v-for="personType in personTypes"
                    :key="personType.id"
                    :value="personType.id"
                    :text="personType.name"/>
              </vs-select>
              <vs-select class="w-full" label="Género" v-model="form.sexo" v-if="form.tipoPersona === 1">
                <vs-select-item
                    v-for="gender in genders"
                    :key="gender.id"
                    :value="gender.id"
                    :text="gender.nombre"/>
              </vs-select>
              <vs-input type="number" class="w-full" label="Edad" v-model="form.edad" v-if="form.tipoPersona === 1"/>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-button
        class="mt-4"
        @click="submitComplaint">
      Generar
    </vs-button>
  </div>
</template>
